<div class="notification-modal">
  <div class="modal-content">
    <h3>{{ isNewPoliza ? 'Crear Nueva Póliza' : 'Agregar Producto a Póliza' }}</h3>
    <p>
      {{ isNewPoliza 
        ? 'Completa los datos para crear una nueva póliza' 
        : 'Selecciona el producto que deseas agregar a tu póliza' }}
    </p>
    
    <!-- Campos para nueva póliza -->
    <div *ngIf="isNewPoliza" class="new-poliza-fields">
      <mat-form-field appearance="fill">
        <mat-label>Número de póliza</mat-label>
        <input matInput [(ngModel)]="polizaNumber" placeholder="Ingresa el número de póliza">
      </mat-form-field>
      
      <mat-form-field appearance="fill">
        <mat-label>Fecha de inicio</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)" placeholder="Selecciona fecha de inicio">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      
      <mat-form-field appearance="fill">
        <mat-label>Fecha de fin</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" [min]="startDate" placeholder="Selecciona fecha de fin" disabled>
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>
    
    <!-- Selector de producto -->
    <select [(ngModel)]="selectedProduct" class="product-select">
      <option [ngValue]="null" disabled>Selecciona un producto</option>
      <option *ngFor="let product of availableProducts" [ngValue]="product">
        {{ product.name }}
      </option>
    </select>

    <div class="modal-buttons">
      <button mat-raised-button class="modal-button cancel" (click)="onCancel()">
        Cancelar
      </button>
      <button mat-raised-button class="modal-button confirm" (click)="onAdd()" [disabled]="!isFormValid">
        {{ isNewPoliza ? 'Crear Póliza' : 'Agregar' }}
      </button>
    </div>
  </div>
</div>